module.exports = __webpack_public_path__ + "static/media/import_csv_icon.21bd9e67.svg";